import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["editToggleButton", "editActionsWrapper", "nameInput", "organizationInputWrapper", "stateInput", "stateDropzone"]

  nameInputTargetConnected(e) {
    e.addEventListener("focusin", () => this.handleShowEditActions('true'));
    e.addEventListener("focusout", () => this.handleShowEditActions('false'));
  }

  refreshOrganizationNameInput() {
    this.handleShowEditActions('false')
    this.nameInputTarget.value = '';
  }

  handleShowEditActions(value) {
    if (value === 'true') {
      this.editActionsWrapperTarget.classList.remove('d-none');
      this.editToggleButtonTarget.classList.add('d-none');
      this.organizationInputWrapperTarget.classList.add('input-border');
    } else {
      this.editActionsWrapperTarget.classList.add('d-none');
      this.editToggleButtonTarget.classList.remove('d-none');
      this.organizationInputWrapperTarget.classList.remove('input-border');
    }
  }

  stateInputTargetConnected(e) {
    e.addEventListener("input", (e) => {
      e.target.value = e.target.value.toUpperCase();
      const searchInput = e.target.value.toLowerCase();
      
      $(this.stateDropzoneTarget).find('.dropzone-item').each(function() {
        const optionText = this.textContent.toLowerCase();
        if (optionText.includes(searchInput) || !searchInput) {
          this.style.display = '';
        } else {
          this.style.display = 'none';
        }
      });
    });

    e.addEventListener("focus", () => {
      this.stateDropzoneTarget.classList.remove("d-none")
    });

    e.addEventListener("focusout", () => {
      setTimeout(() => {
        const userInput = this.stateInputTarget.value.trim().toUpperCase();
        
        if (userInput) {
          // Find exact match
          let matchingOption = $(this.stateDropzoneTarget).find('.dropzone-item').filter(function() {
            return this.textContent.trim() === userInput;
          });

          // If no exact match, check if there's only one visible option
          if (matchingOption.length === 0) {
            const visibleOptions = $(this.stateDropzoneTarget).find('.dropzone-item:visible');
            if (visibleOptions.length === 1) {
              matchingOption = visibleOptions;
            }
          }

          // Apply the match if found
          if (matchingOption.length === 1) {
            this.stateInputTarget.value = matchingOption.get(0).textContent.trim();
          }
          // If no match or multiple matches, leave user input as-is
        }
        
        this.stateDropzoneTarget.classList.add("d-none");
      }, 200);
    });
  }

  selectState(e) {
    const selectedValue = e.currentTarget.dataset.selectValue;
    this.stateInputTarget.value = selectedValue;
    this.stateDropzoneTarget.classList.add("d-none");
  }
}